export const googlePlayLink = 'intent://sniffspot?listing#Intent;scheme=sniffspot;package=com.sniffspot;end';
export const googlePlayLinkUrl = 'https://play.google.com/store/apps/details?id=com.sniffspot';
export const appleStoreLink = 'https://apps.apple.com/us/app/sniffspot/id1437699295';
export const googlePlayMetaAdsLink =
    'https://play.google.com/store/apps/details?id=com.sniffspot&hl=en&referrer=utm_source%3Dfbads%26utm_medium%3Dpaid%26utm_campaign%3Dmetaguest';
export const appleStoreMetaAdsLink = 'https://apps.apple.com/app/apple-store/id1437699295?pt=119310201&ct=metaguest&mt=8';
export const googlePlayTiktokAdsLink =
    'https://play.google.com/store/apps/details?id=com.sniffspot&hl=en&referrer=utm_source%3Dtiktok%26utm_medium%3Dpaid%26utm_campaign%3Dtiktokguest';
export const appleStoreTiktokAdsLink = 'https://apps.apple.com/app/apple-store/id1437699295?pt=119310201&ct=tiktokguest&mt=8';
export const instagramLink = 'https://www.instagram.com/sniffspots/';
export const facebookLink = 'https://www.facebook.com/sniffspots/';
export const tiktokLink = 'https://www.tiktok.com/@sniffspot';
export const youtubeLink = 'https://www.youtube.com/channel/UCewyUhZqykqQMmQgI1Bdmfw';
export const fmdLink = 'https://www.familydogmediation.com/';
export const ppgLink = 'https://www.petprofessionalguild.com/';
export const fbHostGroupLink = 'https://www.facebook.com/groups/sniffspothost';
export const RAW_EMAIL_SUPPORT = 'support@sniffspot.com';
export const EMAIL_SUPPORT = 'Get support';
